import React, { useMemo } from 'react'
import { ICheckGoodRes } from './shop-import'
import { Modal } from '@/components/dialog/modal'
import { layerManage } from '@/utils/layer'
import Table, { ColumnsType } from 'antd/lib/table'

interface IShopImportTip extends ICheckGoodRes {
    onConfirm: (replace: boolean) => void
}

const ShopImportTip: React.FC<IShopImportTip> = props => {
    const column: ColumnsType<{
        id: number
        name: string
    }> = [
        {
            title: '#',
            width: 70,
            dataIndex: 'id',
        },
        {
            title: '商品名',
            dataIndex: 'name',
        },
    ]

    const goods = useMemo(() => {
        return props.goods_names.map((item, index) => ({
            id: index + 1,
            name: item,
        }))
    }, [props.goods_names])

    return (
        <Modal
            headerStyles={{ width: '440px' }}
            isShow
            type="success"
            onClose={() => layerManage.pop()}
            onCancel={() => {
                props.onConfirm(false)
                layerManage.pop()
            }}
            onConfirm={() => {
                layerManage.pop()
                props.onConfirm(true)
            }}
            okText="替换"
            cancelText="不"
        >
            <div data-font-size-20 data-font-weight-600 data-color-000>
                商品库中存在{props.duplicated_goods_count}和同名商品，是否换当前商品？
            </div>
            <div data-font-size-14 data-color-999 data-margin-top-8>
                不替换将不会导入下列商品，可修改名称后再次导入
            </div>
            <div
                style={{
                    width: '480px',
                    border: '1px solid #ddd',
                    height: '200px',
                    marginBottom: '10px',
                    marginTop: '10px',
                }}
            >
                <Table
                    scroll={{ x: 'max-content', y: 150 }}
                    dataSource={goods}
                    columns={column}
                    rowKey={row => row.id}
                    bordered
                    pagination={false}
                />
            </div>
        </Modal>
    )
}

export default ShopImportTip
